import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  select: {
    width: 400,
  },
  button: {
    width: "100%",
  },
}));

export default useStyles;
